import { debounce } from 'lodash';
import React, { useCallback } from 'react';

import { SearchBarProps } from '../../interfaces';
import { Container, SearchBar } from './styles';

const Search: React.FC<SearchBarProps> = ({
  onChange,
  defaultValue = '',
  placeholder = 'Buscar...',
}) => {
  const changer = onChange && debounce(onChange, 500);

  const handleChange = useCallback(
    ({ target: { value } }) => {
      if (changer) return changer(value);

      return null;
    },
    [changer],
  );

  return (
    <Container>
      <SearchBar
        onChange={handleChange}
        placeholder={placeholder}
        defaultValue={defaultValue}
      />
    </Container>
  );
};

export default Search;
